import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { deviceAtom, showGameRulebookAtom, settingsOpenAtom, languageModalOpenAtom, languageAtom } from "../GlobalState";
import { trackEvent } from "../api";
import { Center, Text3D } from "@react-three/drei";
import layout from "../dictionaries/layout";
import { useState } from "react";
import HowToPlay from "./HowToPlay";
import translations from "../dictionaries/translations";

  export default function GameRulebook() {
    const [showRulebook, setShowRulebook] = useAtom(showGameRulebookAtom);
    const device = useAtomValue(deviceAtom)
    const setSettingsOpen = useSetAtom(settingsOpenAtom)
    const setLanguageModalOpen = useSetAtom(languageModalOpenAtom)
    const language = useAtomValue(languageAtom)

    function RulebookButton({ position, scale }) {
      const [hover, setHover] = useState(false)

      function handlePointerEnter(e) {
        e.stopPropagation();
        setHover(true)
      }

      function handlePointerLeave(e) {
        e.stopPropagation();
        setHover(false)
      }

      async function handlePointerUp(e) {
        e.stopPropagation();
        if (showRulebook) {
          setShowRulebook(false)
        } else {
          setShowRulebook(true)
          setSettingsOpen(false)
          setLanguageModalOpen(false)
          await trackEvent({ surface: 'game', action: 'open_rulebook', category: 'ui' })
        }
      }

      return <group position={position} scale={scale}>
        <mesh>
          <boxGeometry args={[1.5, 0.03, 0.6]}/>
          <meshStandardMaterial color={ hover || showRulebook ? 'green': 'yellow' }/>
        </mesh>
        <mesh>
          <boxGeometry args={[1.45, 0.04, 0.5]}/>
          <meshStandardMaterial color='black'/>
        </mesh>
        <mesh 
          name='wrapper' 
          onPointerEnter={e => handlePointerEnter(e)}
          onPointerLeave={e => handlePointerLeave(e)}
          onPointerUp={e => handlePointerUp(e)}
        >
          <boxGeometry args={[1.5, 0.1, 0.6]}/>
          <meshStandardMaterial transparent opacity={0}/>
        </mesh>
        <Center position={[0, 0.05, 0]}>
          <Text3D
            font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
            position={[-0.6,0.02,0.15]}
            rotation={[-Math.PI/2, 0, 0]}
            size={0.3}
            height={0.01}
          >
            {translations.game.rules[language]}
            <meshStandardMaterial color={ hover || showRulebook ? 'green': 'yellow' }/>
          </Text3D>
        </Center>
      </group>
    }

    // Block pointer interactivity behind the book
    function handleRulebookPointerEnter(e) {
      e.stopPropagation()
    }
    function handleRulebookPointerLeave(e) {
      e.stopPropagation()
    }
    function handleRulebookPointerDown(e) {
      e.stopPropagation()
    }
    function handleRulebookPointerUp(e) {
      e.stopPropagation()
    }

    return <group>
      <RulebookButton 
        position={layout[device].game.rulebookButton.position}
        scale={layout[device].game.rulebookButton.scale}
      />
      { showRulebook && <group 
        position={layout[device].game.rulebook.position}
        scale={layout[device].game.rulebook.scale}>
        <group 
          position={layout[device].game.rulebook.blocker.position} 
        >
          <mesh name='blocker-inner' scale={layout[device].game.rulebook.blocker.innerScale}>
            <boxGeometry args={[1,1,1]}/>
            <meshStandardMaterial color='black'/>
          </mesh>
          <mesh name='blocker-outer' scale={layout[device].game.rulebook.blocker.outerScale}>
            <boxGeometry args={[1,1,1]}/>
            <meshStandardMaterial color='orange'/>
          </mesh>
          <mesh name='blocker-wrap' 
            scale={[
              layout[device].game.rulebook.blocker.outerScale[0], 
              layout[device].game.rulebook.blocker.innerScale[1], 
              layout[device].game.rulebook.blocker.outerScale[2], 
            ]}
            onPointerEnter={e=>handleRulebookPointerEnter(e)}
            onPointerLeave={e=>handleRulebookPointerLeave(e)}
            onPointerDown={e=>handleRulebookPointerDown(e)}
            onPointerUp={e=>handleRulebookPointerUp(e)}
          >
            <boxGeometry args={[1,1,1]}/>
            <meshStandardMaterial color='orange' transparent opacity={0}/>
          </mesh>
        </group>
        <Text3D
        font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
        position={layout[device].game.rulebook.title.position}
        rotation={layout[device].game.rulebook.title.rotation}
        size={layout[device].game.rulebook.title.size}
        height={layout[device].game.rulebook.title.height}>
          {translations.lobby.rulebook[language]}
          <meshStandardMaterial color='orange'/>
        </Text3D>
        <HowToPlay
          device={device}
          closeButton={true}
          setShowRulebook={setShowRulebook}
          position={layout[device].game.rulebook.content.position}
        />
      </group> }
    </group>
  }